import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setToast, setLoading, setModal, setLoadingModal } from "Slices/uiSlice";
import { setResponse } from "Slices/Response/responseSlice";
import { UploadFile, UploadFileS3 } from "Slices/File/fileSlice";
import { setPalabrasClaveAsignadas } from "Slices/PalabrasClave/palabraClaveSlice";
import { adminContenidoCurso, deleteContenidoCurso, getContenidoCurso, getTipoContenido } from "Services/contenido_service";
import { adminCurso, asignaciones, categoriaCurso, cursoCategoria, getCursos } from "Services/cursos_service";
import { asignarPalabraClave } from "Services/etiquetas_service";
import { getParamArchivos, getParamValue } from "Services/functions_service";
import { fileUri, TIPOS_CONTENIDO } from "Constantes/constants";
import { getParametros } from "Services/param_service";
import { TOAST_DELAY } from "Constantes/constants";

const initialState = {
    cursos: [],
    curso: {
        idCurso: 0,
        titulo: '',
        duracion: 0,
        estado: 1,
        idCategoria: -1,
        idSubcategoria: -1,
        idIdioma: 1,
        etiquetas: '',
        usuario: '',
        idProducto: null,
        idSegmentoEducativo: null,
        idSegmento: null,
        idDificultad: null,
        img: '',
        file: null,
    },
    categoriaCurso: [],
    cursoCategoria: [],
    palabrasClave: [],
    contenidoCurso: [],
    contenidoSeleccionado: {
        idContenidoCurso: 0,
        tituloContenido: '',
        archivo: '',
        orden: 0,
        idTipoContenido: 0,
        tipoContenido: '',
        formato: '',
        idCurso: 0,
        estado: 1,
    },
    tipoContenido: [],
    tipoContenidoSeleccionado: {
        titulo: '',
        idTipoContenido: 0,
        nombre: '',
        formato: '',
        estado: 1,
    },
    cursosSeleccionados: [],
    asignaciones: [],
}

const folderCursos = getParamArchivos('uriCursos');

export const cursoSlice = createSlice({
    name: 'curso',
    initialState,
    reducers: {
        setCursos: (state, action) => {
            state.cursos = action.payload;
        },
        setCurso: (state, action) => {
            state.curso = action.payload;
        },
        updateCursoField: (state, action) => {
            const { name, value } = action.payload;
            state.curso[name] = value;
        },
        updateCursoFavorite: (state, action) => {
            const { idAlterno, favorito } = action.payload;
            const curso = state.cursos.find(c => c.idAlterno === idAlterno);
            if (curso) curso.favorito = favorito;
        },
        setCategoriaCurso: (state, action) => {
            state.categoriaCurso = action.payload;
        },
        setCursoCategoria: (state, action) => {
            state.cursoCategoria = action.payload;
        },
        setPalabrasClave: (state, action) => {
            state.palabrasClave = action.payload;
        },
        setTipoContenido: (state, action) => {
            state.tipoContenido = action.payload;
        },
        setTipoContenidoSeleccionado: (state, action) => {
            state.tipoContenidoSeleccionado = action.payload;
        },
        setContenidoCurso: (state, action) => {
            state.contenidoCurso = action.payload;
        },
        updateContenidoCursoField: (state, action) => {
            const { name, value } = action.payload;
            state.contenidoSeleccionado[name] = value;
        },
        setContenidoSeleccionado: (state, action) => {
            state.contenidoSeleccionado = action.payload;
        },
        setCursosSeleccionados: (state, action) => {
            state.cursosSeleccionados = action.payload;
        },
        setAsignaciones: (state, action) => {
            state.asignaciones = action.payload;
        },
        resetCurso: (state) => {
            state.curso = initialState.curso;
        },
        resetContenidoSeleccionado: (state) => {
            state.contenidoSeleccionado = initialState.contenidoSeleccionado;
        }
    }
});

export const fetchCursos = createAsyncThunk(
    'curso/fetchCursos',
    async (data, { dispatch }) => {
        // TODO: Activar loading si es necesario.
        // Actualmente desactivado por compatibilidad.
        // dispatch(setLoading(true))
        const cursoRes = await getCursos(data);
        dispatch(setCursos(cursoRes));
        // dispatch(setLoading(false))
    }
);

export const mergeCurso = createAsyncThunk(
    'curso/merge',
    async (data, { dispatch }) => {
        dispatch(setLoadingModal(true))
        const cursoRes = await adminCurso(data);

        if (data.palabrasClaveSeleccionadas) {
            data.palabrasClaveSeleccionadas.map(psc => {
                let dataAsignacion = {
                    idCurso: cursoRes.idCurso,
                    idPalabraClave: psc.idPalabraClave,
                }
                const palabraRes = asignarPalabraClave(dataAsignacion);
            });
        }

        if (data.file) {
            const formData = new FormData();
            formData.append('file', data.file);
            formData.append('tipo', fileUri.portada);
            formData.append('name', `curso_${cursoRes.data}.jpg`);
            await dispatch(UploadFileS3(formData));
        }

        dispatch(setPalabrasClaveAsignadas([]));
        dispatch(setResponse(cursoRes));
        dispatch(setModal(false));
        dispatch(setCurso(initialState.curso));
        dispatch(setToast(true));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);

        dispatch(fetchCursos({ codSegmento: data?.codSegmento }));
        dispatch(setLoadingModal(false));

    }
);

export const fetchCategoriaCurso = createAsyncThunk(
    'curso/fetchCategoriaCurso',
    async (_, { dispatch }) => {
        const cursoRes = await categoriaCurso();
        dispatch(setCategoriaCurso(cursoRes));
    }
);


export const fetchCursoCategoria = createAsyncThunk(
    'curso/fetchCursoCategoria',
    async (data, { dispatch }) => {
        const cursoRes = await cursoCategoria(data);
        dispatch(setCursoCategoria(cursoRes));
    }
);

export const fetchTipoContenidoCurso = createAsyncThunk(
    'curso/fetchTipoContenidoCurso',
    async (data, { dispatch }) => {
        const tipoContenidoRes = await getTipoContenido(data);
        dispatch(setTipoContenido(tipoContenidoRes));
    }
);

export const fetchContenidoCurso = createAsyncThunk(
    'curso/fetchContenidoCurso',
    async (data, { dispatch }) => {
        const contenidoRes = await getContenidoCurso(data);
        dispatch(setContenidoCurso(contenidoRes ? contenidoRes : []));
    }
);

export const mergeContenidoCurso = createAsyncThunk(
    'curso/merge',
    async (data, { dispatch, rejectWithValue, getState }) => {
        dispatch(setLoading(true));
        const contenidoRes = await adminContenidoCurso(data);

        if (!contenidoRes?.result) {
            dispatch(setLoading(false));
            dispatch(setResponse(contenidoRes));
            dispatch(setToast(true));
            setTimeout(() => dispatch(setToast(false)), TOAST_DELAY);
            return rejectWithValue(contenidoRes.message || 'ERROR AL GUARDAR EL CONTENIDO');
        }

        if (data.file) {
            const isELearning = data.archivo.includes(TIPOS_CONTENIDO.E_LEARNING.FORMATO);
            const shouldUseServerStorage = !isELearning && Boolean(data.serverStorage);
            const shouldUseS3Storage = !isELearning && !Boolean(data.serverStorage);

            const formData = new FormData();
            formData.append('file', data.file);
            let uploadResult;

            if (isELearning) {
                const folderData = await getParametros({ codigo: 'uriCursos' });
                const folderCursos = getParamValue(folderData, 'uriCursos', 'codigoParametro', 'parametro');
                formData.append('Folder', `${folderCursos}${data.idCurso}/`);
                formData.append('type', fileUri.elearning);
                uploadResult = await dispatch(UploadFile(formData));
            }

            if (shouldUseServerStorage) {
                const folderData = await getParametros({ codigo: 'uriContenidoCurso' });
                const folderContenido = getParamValue(folderData, 'uriContenidoCurso', 'codigoParametro', 'parametro');
                formData.append('Folder', `${folderContenido}${data.idCurso}/`);
                formData.append('type', fileUri.contenido);
                uploadResult = await dispatch(UploadFile(formData));
            }

            if (shouldUseS3Storage) {
                formData.append('name', `contenido_${data.idCurso}_${data.archivo}`);
                formData.append('tipo', fileUri.contenido);
                uploadResult = await dispatch(UploadFileS3(formData));
            }

            if (!Boolean(uploadResult?.payload?.result)) {
                await dispatch(fetchContenidoCurso(data));
                const material = getState().curso.contenidoCurso.find(c => c.idContenidoCurso === contenidoRes.data);
                dispatch(setContenidoSeleccionado(material));

                dispatch(setLoading(false));
                dispatch(setResponse({ result: 0, message: 'ERROR AL SUBIR EL ARCHIVO' }));
                dispatch(setToast(true));
                setTimeout(() => dispatch(setToast(false)), TOAST_DELAY);

                return rejectWithValue('ERROR AL SUBIR EL ARCHIVO');
            }
        }

        dispatch(setResponse(contenidoRes));
        dispatch(setContenidoSeleccionado(initialState.contenidoSeleccionado));
        dispatch(fetchContenidoCurso(data));
        dispatch(setModal(false));
        dispatch(setLoading(false));
        dispatch(setToast(true));
        setTimeout(() => dispatch(setToast(false)), TOAST_DELAY);
    }
);

export const DeleteContenidoCurso = createAsyncThunk(
    'contenido/delete',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const contenidoRes = await deleteContenidoCurso(data);
        console.log(contenidoRes);
        dispatch(setResponse(contenidoRes));
        dispatch(setLoading(false));
        dispatch(setToast(true));
        dispatch(fetchContenidoCurso(data));
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);


export const fetchAsignaciones = createAsyncThunk(
    'curso/fetchCursos',
    async (data, { dispatch }) => {
        const asignacionesRes = await asignaciones(data);
        dispatch(setAsignaciones(asignacionesRes));
    }
);

export const { setCursos, setCurso, updateCursoField, updateContenidoCursoField, updateCursoFavorite, setCategoriaCurso, setCursoCategoria, setPalabrasClave,
    setTipoContenido, setContenidoCurso, setContenidoSeleccionado, setTipoContenidoSeleccionado, setCursosSeleccionados,
    setAsignaciones, resetCurso, resetContenidoSeleccionado } = cursoSlice.actions;
export default cursoSlice.reducer;